module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_mentorships_text-dcf7535498630ec6b3d589ebfff2ddb4.svg";